import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import i18n from "../../i18n";
export const endpointUrl = process.env.REACT_APP_API_URI;
export const assignedColor = ["#FFC700", "#464E5F", "#3699FF", "#EE436D"];
export const employeeColors = [
  '#959CBD',
  '#3699FF',
  '#959CB6',
  '#FFB423',
  '#0BB783',
  '#8950FC',
  '#1BC5BD',
];
const currentlanguage = localStorage.getItem("language");
export const ssoEndPointUrl = process.env.REACT_APP_SSO_API_URI;
export const ssoReqEndPointUrl=process.env.REACT_APP_SSO_REQ_API_URI;
// export const endpointUrl = "https://vorpapi.visibleone.com/api/v1/";
// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URI}`,
  prepareHeaders: (headers, { getState }) => {
    headers.append("Accept", `application/json`);
    headers.set("Content-Type", `application/json`);
    return headers;
  },
});
export const change_axios_language=()=>{
  const lng=window.localStorage.getItem('language');
    i18n.changeLanguage(lng?lng:'en');
}
export const getLanguageCodeForbackend=()=>{  
  const curLanguage = localStorage.getItem("language");
  if(curLanguage=='zh'){
    return 'tc/';
  }else if(curLanguage=='cn'){
    return 'sc/';
  }else{
    return 'en/';
  }
}
export const getLanguageCode=()=>{  
  return currentlanguage ? currentlanguage+'/' : "en/";
}
export const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });

/**
 * Create a base API to inject endpoints into elsewhere.
 * Components using this API should import from the injected site,
 * in order to get the appropriate types,
 * and to ensure that the file injecting the endpoints is loaded
 */
export const api = createApi({
  /**
   * A bare bones base query would just be `baseQuery: fetchBaseQuery({ baseUrl: '/' })`
   */
  baseQuery: baseQueryWithRetry,
  keepUnusedDataFor: 30 * 60 * 1000,
  // refetchOnFocus: true,
  // refetchOnReconnect: true,
  /**
   * Tag types must be defined in the original API definition
   * for any tags that would be provided by injected endpoints
   */
  // tagTypes: ['Users', 'Posts', 'Products',"Permissions","rTData","UsersList","RoleData","EmployeeListData", "CreateAnnoun", "Tags"],
  tagTypes: [
    "Login",
    "ClaimTypeList",
    "Users",
    "Posts",
    "Products",
    "Permissions",
    "UsersList",
    "RoleData",
    "EmployeeListData",
    "TemplateList",
    "templateData",
    "templateSpecificData",
    "addTempleData",
    "DepartmentList",
    "DesignationList",
    "CurrencyList",
    "ContryList",
    "CreateAnnoun",
    "Tags",
    "CreateeAnnounSheet",
    "tagsDataList",
    "Password",
    "EventList",
    "ProjectListData",
    "ProjectTypeList",
    "EventTypes",
    "PasswordList",
    "LeaveDataList",
    "ProjectStatusList",
    "KeyDateList",
    "PaymentStatusList",
    "RegionsList",
    "QuotationNoList",
    "CheckList",
    "PaymentList",
    "ProfileList",
    "MyProfileList",
    "MyGoal",
    "ImportProjects",
    "CheckInOut",
    "MyTimeSheet",
    "MyAuthLeaves",
    "MyAuthLeaveBalance",
    "MyAuthLeaveTypes",
    "LeaveData",
    "MyPasswordList",
    "MyEmpyTimeSheet",
    "TimeSheetDetail",
    "EmployeeList",
    "RoleListData",
    "GetTimeSheet",
    "Documents",
    "Medias",
    "MyPasswordList",
    "TagsCustom",
    "ProfileListData",
    "OTList",
    "LeaveAllowanceList",
    "OnePasswordList",
    "KeyPasswordList",
    "PasswordLog",
    "ListUsers",
    "IsKeyPwd",
    "UserAssign",
    "Notification",
    "AnnoucementData",
    "NotificationList",
    "Claims",
    "MyClaims",
    "EmployeeIncentive",
    "OffDay",
    "ProjectTech",
    "ProjectType",
    "KeyDate",
    // "ExchangeRate"
    "ExchangeRate",
    "PayRoll",
    "ProfileDailyReport",
    "ProfileDailyReportPopup",
    "ProgressChecker",
    "ProfileTaskName",
    "TaskList",
    "TaskDetailList",
    "EmployeeAssign",
    "EmployeeAssignRow",
    "TaskCategories",
    "Departments",
    "ProfileProjects",
    "PayRollFilterData",
    "ClaimsFilter",
    "ProfileDailyReportRefillPopup",
    "DailyReportFilterData",
    "ProjectBoardFilter",
    "ProjectBoardStatus",
    "ProjectStatus",
    "KeyDateDataList",
    "LeaveInformation",
    "LeaveTaken",
    "Monitoring",
    "EmployeeDevice",
    "MonitoringScreenShot",
    "LeaveType",
    "WorkingShift",
    "NoticeBoard",
    "Category"
    // 'PJTypeList', 'PJStatusList', 'RegionList', "rTData",
  ],

  /**
   * This api has endpoints injected in adjacent files,
   * which is why no endpoints are shown below.
   * If you want all endpoints defined in the same file, they could be included here instead
   */
  endpoints: () => ({}),
});
